function applyLinkStyles(linkStyles, baseElement) {
  if (!baseElement) return;

  Object.entries(linkStyles).forEach(([className, styles]) => {
    baseElement.querySelectorAll(`.${className}`).forEach((domElement) => {
      Object.entries(styles).forEach(([property, value]) => {
        // eslint-disable-next-line no-param-reassign
        domElement.style[property] = value;
      });
    });
  });
}

function updateLinkStyles(el, binding) {
  binding.instance.$nextTick(() => {
    const { element } = binding.instance;
    const linkStyles = element?.postSettings?.linkStyles;

    if (linkStyles) {
      const socialElement = el.id === element.id ? el : document.getElementById(element.id);
      applyLinkStyles(linkStyles, socialElement);
    }
  });
}

export default {
  mounted: updateLinkStyles,
  updated: updateLinkStyles,
};
